// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3j93c","head":"Card_head__3TGzh","title":"Card_title__16Xzl"};